export default __webpack_public_path__ + "static/media/ped.35c73aca.jpg";